import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgTechnisch = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00C5F2"
      d="M33.8 22.33h-2.37a11.5 11.5 0 0 1-1.7 4.1l1.68 1.68a.19.19 0 0 1 0 .28l-3 3a.19.19 0 0 1-.28 0l-1.68-1.68a11.5 11.5 0 0 1-4.1 1.7v2.39a.19.19 0 0 1-.115.185.2.2 0 0 1-.075.015h-4.3a.19.19 0 0 1-.19-.2v-2.37a11.5 11.5 0 0 1-4.1-1.7l-1.68 1.68a.19.19 0 0 1-.28 0l-3-3a.19.19 0 0 1 0-.28l1.68-1.68a11.5 11.5 0 0 1-1.7-4.1H6.2a.19.19 0 0 1-.185-.115A.2.2 0 0 1 6 22.16v-4.3a.19.19 0 0 1 .2-.19h2.37a11.5 11.5 0 0 1 1.7-4.1l-1.68-1.68a.19.19 0 0 1 0-.28l3-3a.19.19 0 0 1 .28 0l1.68 1.68a11.5 11.5 0 0 1 4.1-1.7V6.2a.19.19 0 0 1 .115-.185A.2.2 0 0 1 17.84 6h4.28a.19.19 0 0 1 .19.2v2.37a11.5 11.5 0 0 1 4.1 1.7l1.68-1.68a.19.19 0 0 1 .28 0l3 3a.19.19 0 0 1 0 .28l-1.68 1.68a11.5 11.5 0 0 1 1.7 4.1h2.41a.19.19 0 0 1 .185.115.2.2 0 0 1 .015.075v4.28a.19.19 0 0 1-.12.197.2.2 0 0 1-.08.013M20 26a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M21.296 14.457A6 6 0 1 0 19 26v1a7 7 0 1 1 7-7h-1a6 6 0 0 0-3.704-5.543"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgTechnisch);

export default ForwardRef;
